// 차수별현황 – 매도 등록 팝업
// props: data { buy_id, account_name, stock_name, ticker, turn_no,
//               current_price, quantity, buy_amount, buy_price }
//        onClose: 닫기 콜백
//        onSaved: 저장 성공 후 콜백
import React, { useState, useEffect } from 'react';
import { createSell } from '../../api/sell';

const todayStr = () => new Date().toISOString().substring(0, 10);

const fAmt = (v) => {
  if (v == null || isNaN(Number(v))) return '';
  return Math.round(Number(v)).toLocaleString('ko-KR');
};

const TurnSellPopup = ({ data, onClose, onSaved }) => {
  const [sellDate,  setSellDate]  = useState(todayStr());
  const [sellPrice, setSellPrice] = useState(data.current_price != null ? String(data.current_price) : '');
  const [quantity,  setQuantity]  = useState(data.quantity  != null ? String(data.quantity)  : '');
  const [memo,      setMemo]      = useState('');
  const [saving,    setSaving]    = useState(false);
  const [error,     setError]     = useState('');

  // ESC 키로 닫기
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  const sp  = Number(sellPrice) || 0;
  const qty = Number(quantity)  || 0;
  const bp  = data.buy_price    || 0;

  const sellAmt    = sp * qty;
  // 수익금액: (매도단가 - 매수단가) × 수량  → 백엔드 로직과 동일
  const profit     = qty > 0 && bp > 0 ? (sp - bp) * qty : null;
  const profitRate = profit != null && bp > 0 && qty > 0
    ? Math.round(profit / (bp * qty) * 10000) / 100
    : null;

  const handleSave = async () => {
    if (!sellDate)       return setError('매도일자를 입력하세요.');
    if (!(sp > 0))       return setError('매도단가를 입력하세요.');
    if (!(qty > 0))      return setError('수량을 입력하세요.');
    setSaving(true);
    setError('');
    try {
      await createSell({
        buy_id:     data.buy_id,
        sell_date:  sellDate,
        sell_price: sp,
        quantity:   qty,
        memo:       memo || undefined,
      });
      onSaved();
    } catch (e) {
      setError(e.response?.data?.detail || '저장에 실패했습니다.');
    } finally {
      setSaving(false);
    }
  };

  const profitCls = profit != null
    ? profit > 0 ? 'profit-pos' : profit < 0 ? 'profit-neg' : ''
    : '';

  return (
    <div className="popup-overlay" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="popup-box">
        <div className="popup-title sell-title">
          매도 등록 &mdash; {data.stock_name || data.ticker} {data.turn_no}차
        </div>

        <div className="popup-body">
          <table className="popup-form">
            <tbody>
              <tr>
                <th>계좌명</th>
                <td><input readOnly value={data.account_name} className="popup-input readonly" /></td>
              </tr>
              <tr>
                <th>종목명</th>
                <td><input readOnly value={data.stock_name || data.ticker} className="popup-input readonly" /></td>
              </tr>
              <tr>
                <th>티커</th>
                <td><input readOnly value={data.ticker} className="popup-input readonly" /></td>
              </tr>
              <tr>
                <th>차수</th>
                <td><input readOnly value={`${data.turn_no}차`} className="popup-input readonly" /></td>
              </tr>
              <tr><td colSpan={2} className="popup-divider" /></tr>
              <tr>
                <th>매도일자 *</th>
                <td>
                  <input
                    type="date"
                    value={sellDate}
                    onChange={e => setSellDate(e.target.value)}
                    className="popup-input"
                  />
                </td>
              </tr>
              <tr>
                <th>매도단가 *</th>
                <td>
                  <input
                    type="number"
                    value={sellPrice}
                    onChange={e => setSellPrice(e.target.value)}
                    className="popup-input"
                    min="0"
                    step="any"
                    placeholder="현재가"
                  />
                </td>
              </tr>
              <tr>
                <th>수량 *</th>
                <td>
                  <input
                    type="number"
                    value={quantity}
                    onChange={e => setQuantity(e.target.value)}
                    className="popup-input"
                    min="0"
                    step="any"
                  />
                </td>
              </tr>
              <tr>
                <th>매도금액</th>
                <td>
                  <input readOnly value={sellAmt > 0 ? fAmt(sellAmt) : ''} className="popup-input readonly right" />
                </td>
              </tr>
              <tr>
                <th>수익금액</th>
                <td>
                  <input
                    readOnly
                    value={profit != null ? fAmt(profit) : ''}
                    className={`popup-input readonly right ${profitCls}`}
                  />
                </td>
              </tr>
              <tr>
                <th>수익률</th>
                <td>
                  <input
                    readOnly
                    value={profitRate != null
                      ? `${profitRate > 0 ? '+' : ''}${profitRate.toFixed(2)}%`
                      : ''}
                    className={`popup-input readonly right ${profitCls}`}
                  />
                </td>
              </tr>
              <tr>
                <th>메모</th>
                <td>
                  <input
                    value={memo}
                    onChange={e => setMemo(e.target.value)}
                    className="popup-input"
                    maxLength={200}
                    placeholder="선택 입력"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          {error && <div className="popup-error">{error}</div>}
        </div>

        <div className="popup-footer">
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? '저장 중...' : '저장'}
          </button>
          <button className="btn btn-secondary" onClick={onClose} disabled={saving}>
            취소
          </button>
        </div>
      </div>
    </div>
  );
};

export default TurnSellPopup;
